export default __webpack_public_path__ + "static/media/EMbZwloUUAIMjUk.dcabfa10.jpg";